"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var RoomModule = /** @class */ (function (_super) {
    __extends(RoomModule, _super);
    function RoomModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询房间绑定物品
     * @param roomId 房间Id
     */
    RoomModule.prototype.queryBindingRoomGoodsList = function (roomId, token) {
        return this.gatewayClient.queryBindingRoomGoodsList(roomId, token);
    };
    /**
     * 编辑房间物品（修改/删除）
     * @param goodsList
     * eg. data=[{"goodsId":"51","roomId":"8171","goodsNum":"1","createName":"dev"}]
     */
    RoomModule.prototype.addRoomGoods = function (roomId, goodsList, token) {
        return this.gatewayClient.addRoomGoods(roomId, goodsList, token);
    };
    /**
     * 更新未关联门店楼宇房间省市区
     * @param roomId 房间id
     * @param province 省
     * @param city 市
     * @param district 区
     */
    RoomModule.prototype.updateRoomArea = function (params, token) {
        return this.gatewayClient.updateRoomArea(params, token);
    };
    /**
     * 批量删除房间图片
     * @param ids 图片(素材)id 多个id使用,号分隔
     * @param token
     */
    RoomModule.prototype.delRoomFlacks = function (ids, token) {
        return this.gatewayClient.delRoomFlacks(ids, token);
    };
    /**
     * 查询房间修改记录
     * @param page
     * @param pageSize
     * @param roomId
     * @param token
     */
    RoomModule.prototype.editRoomLog = function (page, pageSize, roomId, token) {
        return this.gatewayClient.editRoomLog(page, pageSize, roomId, token);
    };
    /**
     * 省市门店下拉框
     */
    RoomModule.prototype.citiesHotellist = function (param, token) {
        return this.gatewayClient.citiesHotellist(param, token);
    };
    /**
     * 复制房间分页查询房间列表
     * @param param
     * @param token
     */
    RoomModule.prototype.getRoomlist = function (param, token) {
        return this.gatewayClient.getRoomlist(param, token);
    };
    /**
     * 复制房间分页查询房间列表
     * @param param
     * @param token
     */
    RoomModule.prototype.getOtherRoomlist = function (param, token) {
        return this.gatewayClient.getOtherRoomlist(param, token);
    };
    /**
     * 复制图片 - 复制到指定房间
     */
    RoomModule.prototype.copyImgToRoom = function (param, token) {
        return this.gatewayClient.copyImgToRoom(param, token);
    };
    /**
     * 批量更改房间预售状态
     */
    RoomModule.prototype.updatePresaleBatname = function (param, token) {
        return this.gatewayClient.updatePresaleBatname(param, token);
    };
    /**
     * roomSystem-api
     * @param params
     * @param method
     * @param token
     */
    RoomModule.prototype.roomSystem = function (params, method, token, data) {
        return this.gatewayClient.roomSystem(params, method, token, data);
    };
    /**
     * room-api
     * @param params
     * @param method
     * @param token
     */
    RoomModule.prototype.roomApi = function (params, method, token, data) {
        return this.gatewayClient.roomApi(params, method, token, data);
    };
    return RoomModule;
}(gateway_module_1.GatewayModule));
exports.RoomModule = RoomModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/room/index.js
// module id = 215
// module chunks = 44